export const newsStaticData = () => [
  {
    id: "1",
    published: "2025-01-24",
    url: "https://www.tribuneindia.com/news/business/bataiyo-indias-first-zero-commission-super-app-launches-on-january-26-2025/",
    title:
      "Bataiyo to Launch on Republic Day: India’s First Zero-Commission Super App for Trusted Services",
    channelName: "The Tribune",
  },
  {
    id: "2",
    published: "2025-01-24",
    url: "https://www.aninews.in/news/business/bataiyo-indias-first-zero-commission-super-app-launches-on-january-26-202520250124160217/",
    title:
      "Bataiyo, India's First Zero-Commission Super App, Launches on January 26, 2025",
    channelName: "ANI",
  },
  {
    id: "3",
    published: "2024-08-15",
    url: "https://www.lokmattimes.com/business/bataiyo-registration-begins-this-independence-day-revolutionizing-digital-connections-with-a-zero-commission-model/",
    title:
      "Bataiyo Registration Begins This Independence Day: Revolutionizing Digital Connections with a Zero-Commission Model",
    channelName: "Lokmat Times",
  },
];
